import { render, staticRenderFns } from "./AcademyBranchListPanel.vue?vue&type=template&id=4158e636&scoped=true&lang=pug&"
import script from "./AcademyBranchListPanel.vue?vue&type=script&lang=ts&"
export * from "./AcademyBranchListPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyBranchListPanel.vue?vue&type=style&index=0&id=4158e636&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158e636",
  null
  
)

export default component.exports